module.exports = __webpack_public_path__ + "static/media/boat.5c9eceea.png";